module.exports = __webpack_public_path__ + "static/media/3.745cda94.jpg";